import { useState } from 'react';

interface WritersHeroProps {
  searchQuery: string;
  onSearchChange: (q: string) => void;
}

const WritersHero = ({ searchQuery, onSearchChange }: WritersHeroProps) => {
  const [focused, setFocused] = useState(false);

  return (
    <section className="relative pt-16 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e723ea2b360cf1b87515737a6aa8b72e.jpg"
          alt="Writers"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-[#0a0a0a]" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-black/40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 py-24 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-red-900/30 border border-red-900/50 rounded-full text-red-400 text-sm font-['Crimson_Text'] mb-6">
          <i className="ri-quill-pen-line" />
          The Dark Authors
        </div>

        <h1 className="text-5xl md:text-6xl font-bold text-white font-['Cinzel'] tracking-wider mb-4 drop-shadow-2xl">
          Meet the <span className="text-red-600">Writers</span>
        </h1>

        <p className="text-xl text-gray-300 font-['Crimson_Text'] italic mb-10 max-w-2xl mx-auto leading-relaxed">
          The twisted minds behind the tales. Discover the authors who dare to explore the darkest corners of imagination.
        </p>

        {/* Search */}
        <div className="max-w-xl mx-auto">
          <div className={`flex items-center gap-3 bg-black/60 backdrop-blur-sm border rounded-lg px-4 py-3 transition-all duration-300 ${focused ? 'border-red-600/60 shadow-lg shadow-red-900/20' : 'border-red-900/30'}`}>
            <div className="w-5 h-5 flex items-center justify-center shrink-0">
              <i className="ri-search-line text-gray-400 text-sm" />
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              placeholder="Search writers by name or bio..."
              className="flex-1 bg-transparent text-white text-sm font-['Crimson_Text'] placeholder-gray-500 outline-none"
            />
            {searchQuery && (
              <button
                onClick={() => onSearchChange('')}
                className="w-5 h-5 flex items-center justify-center text-gray-500 hover:text-white transition-colors cursor-pointer shrink-0"
              >
                <i className="ri-close-line text-sm" />
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WritersHero;
